import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

// Components 

import Box from '@mui/material/Box';
import { getConsultationLanguage, getConsultationNote, getConsultationNoteWithPin, getConsultationWithPin, getNoteFieldsWithPin, updateConsultationNote } from '../../routes/doctor/consultation';
import { setConsultationInfo, setConsultationNoteId, setInfo, setIsMicrophoneDisabled, setIsMicWarningOpened, setLanguage, setMode, setNoteFields, setSecurityPin } from '../../redux/features/doctor/Dashboard/consultation/noteMicrophone';
import Header from './header/Header';
import Footer from './footer/Footer';
import AutoComplete from './autoComplete/AutoComplete';
import MicrophoneDisabled from './popups/MicrophoneDisabled';
import Options from './options/Options';
import Fields from './autoComplete/Fields';
import Interface from '../general/containers/Interface';

// -- 

const Container: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId, consultationNoteId, securityPin } = useParams() as any; 

    const colors = useAppSelector(state => state.theme.colors); 
    const accountInfo = useAppSelector(state => state.meta.accountInfo); 

    const isRecording = useAppSelector(state => state.noteMicrophone.isRecording); 
    const isMicrophoneDisabled = useAppSelector(state => state.noteMicrophone.isMicrophoneDisabled); 
    const isOptionsListOpened = useAppSelector(state => state.noteMicrophone.isOptionsListOpened); 
    const isFieldsListOpened = useAppSelector(state => state.noteMicrophone.isFieldsListOpened); 
    const isMicWarningOpened = useAppSelector(state => state.noteMicrophone.isMicWarningOpened); 
    const mode = useAppSelector(state => state.noteMicrophone.mode);

    const [timeLeft, setTimeLeft] = useState(2); 

    // -- 

    window.onbeforeunload = function (e: any) {

      if (isRecording) { 

        resetConsultationRecording(); 
  
        // For IE and Firefox
  
        if (e) {
          e.returnValue;
        }; 
      
        // For Safari
        return e.returnValue;
  
      };
  
    };

    // -- 

    const resetConsultationRecording = async () => { 

        const content = { 
            consultationNoteId,
            securityPin, 
            stopRecording: true,
        }; 

        updateConsultationNote(content); 

    }; 

    // -- 

    const handleConsultationLanguage = async () => { 

      const res = await getConsultationLanguage(consultationNoteId) as any; 

      if (res.data.status === 200) { 

        dispatch(setLanguage(res.data.language)); 

      }; 

    }; 

    // -- 

    const handleConsultation = async () => { 

      const res = await getConsultationWithPin(consultationId, securityPin) as any; 

      if (res.data.status == 200) { 

        dispatch(setConsultationInfo(res.data.consultation)); 

      }; 

    }; 

    // -- 
  
    const handleConsultationNote = async () => { 
  
      const res = await getConsultationNoteWithPin(consultationNoteId, securityPin) as any; 
  
      if (res.data.status === 200) { 
  
        const { consultationNote } = res.data; 

        if (consultationNote) { 

          dispatch(setInfo(consultationNote)); 

        }; 

        if ((consultationNote?.isRecording) && (consultationNote?.micType == 'desktop')) { 
          
          dispatch(setIsMicrophoneDisabled(true))

        } else { 

          dispatch(setIsMicrophoneDisabled(false)); 

        };

      } else { 
  
        navigate('/dashboard'); 
  
        window.location.reload(); 
  
      }; 
  
    }; 

    // -- 

    useEffect(() => { 

        if (consultationNoteId) { 

            dispatch(setConsultationNoteId(consultationNoteId)); 

            handleConsultationLanguage(); 

        }; 

    },[consultationNoteId]); 

    // -- 

    useEffect(() => { 

      if (securityPin) { 

        dispatch(setSecurityPin(securityPin)); 

      }; 

    },[securityPin]); 

    // -- 
  
    useEffect(()=>{
  
        let myInterval = setInterval(() => {
  
            if (timeLeft > 0) {
  
                setTimeLeft(timeLeft - 1);
  
            }; 
  
            if (timeLeft === 1) { 
  
              if (consultationNoteId && securityPin) { 

                handleConsultationNote(); 

                handleConsultation(); 
  
              };
  
              setTimeLeft(2); 
  
            }; 
  
            if (timeLeft === 0) {
  
                if (timeLeft === 0) {
                    clearInterval(myInterval)
                };
            }; 
  
        }, 500); 
  
        return ()=> {
            clearInterval(myInterval);
        };
  
    },[timeLeft]);

    // -- 

    return (

      <Interface>

        <Header /> 

        {isMicrophoneDisabled && <MicrophoneDisabled />}

        <Footer /> 

        {/* { (mode === 'autoComplete') && <AutoComplete />}

        {isOptionsListOpened && <Options />} 

        {isFieldsListOpened && <Fields />}  */}

      </Interface>

  );

};

export default Container;